module.exports = __webpack_public_path__ + "static/media/dark_icn_map_fermata_lex_selected.159be4e0.svg";